module.exports = __webpack_public_path__ + "img/entity_05.1ba37df5.jpg";